import { render } from "./UsersTab.vue?vue&type=template&id=2ad67b5a&scoped=true"
import script from "./UsersTab.vue?vue&type=script&lang=js"
export * from "./UsersTab.vue?vue&type=script&lang=js"

import "./UsersTab.vue?vue&type=style&index=0&id=2ad67b5a&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad67b5a"]])

export default __exports__